import {
  BasicIcon,
  HeaderType,
  Table,
  ToolTipPosition,
  Tooltip,
} from "@pickit/pickit-components";
import { useTranslation } from "react-i18next";
import { DelayedTripsProps } from "./types";
import { DelayedTrip } from "reducers/types/dashboard";
import { DASHBOARD_TABLES_LIMIT } from "utils/constants";
import { useCallback } from "react";

const DelayedTrips = ({
  delayedTrips,
  countryCode,
  quantity,
  currentPage,
  setTripPage,
}: DelayedTripsProps) => {
  const { t } = useTranslation("dashboard");

  const headers: HeaderType<DelayedTrip>[] = [
    {
      key: "code",
      label: t("tripId"),
      type: "button",
      buttonConfig: {
        hierarchy: "minimal",
        onClick: (row) => {
          window.open(`/${countryCode}/transaction?tripId=${row.code}`);
        },
        valueLabel: true,
      },
      testId: 'trip-id',
    },
    {
      key: ["pendingTransactions", "totalTransactions"],
      label: t("trxAmount"),
      textConfig: {
        separator: "/",
      },
      testId: 'trx-amount',
    },
    {
      key: "workZoneName",
      label: t("workzone"),
      col: 4,
      testId: 'workzone',
    },
    {
      key: "lastStateUpdate",
      label: t("fuo"),
      textConfig: {
        formatter: (min) => {
          const minutes = Number(min);
          if (minutes < 60) return `${min} ${t("minutes")}`;

          const hour = Math.trunc(minutes / 60);
          const addedMinutes = minutes % 60;
          return `${hour}:${
            addedMinutes < 10 ? `0${addedMinutes}` : addedMinutes
          } ${hour > 1 ? t("hours") : t("hour")}`;
        },
      },
      col: 4,
      testId: 'fuo',
    },
    {
      key: "pickerId",
      label: t("pickerId"),
      type: "button",
      buttonConfig: {
        valueLabel: true,
        hierarchy: "minimal",
        onClick: (row) =>
          window.open(`/${countryCode}/pickers/detail/${row.pickerId}`),
      },
      testId: 'picker-id',
    },
  ];

  const handlePageChange = useCallback(
    (page: number) => {
      setTripPage(page);
    },
    [setTripPage]
  );

  return (
    <>
      <div className="table-title-container">
        <h3 className="table-title" data-testid="delayed-trips-title">{t("delayedTrips")}</h3>
        <div className="tooltip-icon" data-testid="delayed-trips-tooltip">
          <Tooltip
            message={t("delayedTripsTooltip")}
            position={ToolTipPosition.right}
          >
            <BasicIcon
              name="information-circle"
              size="small"
              color="#0098ff"
            />
          </Tooltip>
        </div>
      </div>
      <Table<DelayedTrip>
        headers={headers}
        data={delayedTrips.slice(
          DASHBOARD_TABLES_LIMIT * currentPage,
          DASHBOARD_TABLES_LIMIT * (currentPage + 1)
        )}
        cols={18}
        rowCount={10}
        pagination="paginator"
        pages={{
          currentPage,
          totalPages: Math.ceil(quantity / DASHBOARD_TABLES_LIMIT),
        }}
        noResultsText={t("noResults")}
        onChangePage={handlePageChange}
        testId="delayed-trips-table"
      />
    </>
  );
};

export default DelayedTrips;
